// extracted by mini-css-extract-plugin
export default {"imagegallerygrid":"imagegallerygrid_imagegallerygrid__8nR3b","wrapperImages":"imagegallerygrid_wrapperImages__fmQ46","wrapperBtn":"imagegallerygrid_wrapperBtn__dAzfr"};